export default function Pagination({ nPages, currentPage, setCurrentPage, totalRecords, indexOfFirstRecord, indexOfLastRecord }) {

    const nextPage = () => {
        if(currentPage === nPages){
            setCurrentPage(() => currentPage)
        }else{
            setCurrentPage(() => currentPage + 1)
        }
    }

    const prevPage = () => {
        if(currentPage === 1){
            setCurrentPage(() => currentPage)
        }else{
            setCurrentPage(() => currentPage - 1)
        }
    }

    return (
      <nav
        className="flex items-center justify-between border-t border-gray-200 bg-primarioMira px-4 py-5 sm:px-6 rounded-b-lg"
        aria-label="Pagination"
      >
        <div className="hidden sm:block">
          <p className="text-sm text-white">
            Mostrando <span className="font-medium">{indexOfFirstRecord + 1}</span> hasta <span className="font-medium">{currentPage === nPages ? totalRecords : indexOfLastRecord}</span> de
            <span className="font-medium"> {totalRecords} </span> resultados
          </p>
        </div>
        <div className="flex flex-1 justify-between sm:justify-end  h-10">
          <button
            type="button"
            className="relative inline-flex items-center rounded-md border border-transparent bg-secundario px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-secundario hover:border-2"
            onClick={() => prevPage()}
          >
            Atrás
          </button>
          <button
            type="button"
            className="relative ml-3 inline-flex items-center rounded-md border border-transparent bg-secundario px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-secundario hover:border-2"
            onClick={() => nextPage()}
          >
            Siguiente
          </button>
        </div>
      </nav>
    )
  }
